import { makeAutoObservable } from 'mobx'

const styles = {
    invert: false,
    zoom: 1,
    contrast: 1,
    brightness: 1,
	scaleX: 1,
	scaleY: 1,
	rotate: 0
}

class ViewerStore {
  attributes
  history = []
  workspace = []
  selectedWindowId = ''
  viewerMode: viewerMode = 1
  magnifier = false
  count = ''
  mode = ''

  timer = ""


  constructor() {
    makeAutoObservable(this)
  }
  //Сеттеры
  setTimer = (timer) => {
    this.timer = timer
  }
  setMode = (mode) => {
    this.mode = mode
  }
  setCount = (value) => {
    this.count = value
  }
  setHistory = async (history) => {
    this.history = history
	console.log('settling history', history, 'while',this.selectedWindowId=='')
    // @ts-ignore
	if (this.selectedWindowId=='') {
		history?.length >= 0 && 
			await this.pushToWorkspace(history[0]?._id, history[0]?.resultDate)
	}
  }

  setAttributes = async (attributes) => {
	console.log('settling attributes', attributes)
    this.attributes = attributes
	if (attributes && attributes.id) {	
		console.log('changing window to', attributes.id)
		if (this.selectedWindowId!=attributes.id) {
			await this.pushFromHistory(attributes.id, attributes.result_date)
		}
		//this.selectWindow(attributes.id)
	}	
  }

  //Создание окна
  createWindow = async (id, date) => {

    return {
      styles,
      id,
      date,
      imageSrc: ""
    }
  }
  //Добавление окна в рабочее пространства
  pushToWorkspace = async (id, date) => {
	console.log('pushToWorkspace',id)
    id && date && this.workspace.push(await this.createWindow(id, date))
    this.selectWindow(id)
  }

  // Добавление окна из истории
  pushFromHistory = async (id, date) => {
	console.log('pushFromHistory',id)
    const workspaceIds = this.workspace.map((item) => item.id)
    let selectedWindowIdInWorkspace = workspaceIds.indexOf(this.selectedWindowId)
	selectedWindowIdInWorkspace = selectedWindowIdInWorkspace ? selectedWindowIdInWorkspace : 0;

    //Проверка на то, что бы не было двух окон с одинаковыми id
    if (!workspaceIds.includes(id)) {
	  // открываем новое окно
      switch (this.viewerMode) {
        case 1:
          this.workspace.splice(0, 1, await this.createWindow(id, date))
          break

        case 2:
          if (this.workspace.length === 2)
            this.workspace.splice(selectedWindowIdInWorkspace, 1, await this.createWindow(id, date))
          else await this.pushToWorkspace(id, date)
          break

        case 4:
          if (this.workspace.length === 4) {
			this.workspace.splice(selectedWindowIdInWorkspace, 1, await this.createWindow(id, date)) 
			/*
            this.workspace.map(async (item, index) => {
              if (this.selectedWindowId === item.id) {
                if (item.id === this.workspace[0].id)
                  this.workspace.splice(1, 1, await this.createWindow(id, date))
                else
                  this.workspace.splice(
                      index,
                      1,
                      await this.createWindow(id, date)
                  )
              }
            })
			*/
          } else await this.pushToWorkspace(id, date)
          break
      }
      this.selectWindow(id)
	  
    } else {
	  // меняем окна	
	}

    if (workspaceIds.includes(id)) this.selectWindow(id)
  }
// Изменение сетки рабочего пространства
  changeViewerMode = async (mode) => {
    const workspaceIds = this.workspace.map((item) => item.id)

    switch (mode) {
      case 1:
        const id = this.history[0]?._id
        const date = this.history[0]?.resultDate
        this.workspace = id && date ? [await this.createWindow(id, date)] : []
        this.selectWindow(id)
        this.viewerMode = mode
        break
      case 2:
        if (this.viewerMode === 4) {
          this.workspace.splice(2, 2)
          this.selectWindow(workspaceIds[0])
        }
        if (this.viewerMode === 1) {
          let length = this.workspace.length
          this.history.forEach((item) => {
            if (length <= 1) {
              if (!workspaceIds.includes(item._id)) {
                this.pushToWorkspace(item._id, item.resultDate)
                length++
              }
            }
          })
        }
        this.viewerMode = mode
        break
      case 4:
        let length = this.workspace.length
        this.history.forEach((item) => {
          if (length <= 3) {
            if (!workspaceIds.includes(item._id)) {
              this.pushToWorkspace(item._id, item.resultDate)
              length++
            }
          }
        })
        this.viewerMode = mode
        break
    }
  }

  //Выбор окна.
  selectWindow = (id) => {
	  console.log('selectWindow',id)
    this.selectedWindowId = id
  }

  //Переключение снимка внутри окна
  switchWindow = async (id, direction) => {
    const workspaceIds = this.workspace.map((item) => item.id)
    const historyIds = this.history.map((item) => item._id)
    const indexInWorkspace = workspaceIds.indexOf(id)
    const indexInHistory = historyIds.indexOf(id)

    console.log('Switching',id,direction)
    for (
        let i = indexInHistory + (direction === 'next' ? 1 : -1);
        i < historyIds.length && i >= 0;
        direction === 'next' ? i++ : i--
    ) {
	  if (this.history[i]?._id) {
		if (workspaceIds.includes(historyIds[i])) {
			this.workspace[indexInWorkspace] = {}
			let swapId = workspaceIds.indexOf(historyIds[i]);
			this.workspace[swapId] = await this.createWindow(
				this.history[indexInHistory]._id,
				this.history[indexInHistory].resultDate
			)		
		}
		this.workspace[indexInWorkspace] = await this.createWindow(
		  this.history[i]._id,
		  this.history[i].resultDate
		)
		this.selectWindow(this.history[i]?._id)
		break
	  }
    }
  }

  changeStyles = (id, styleType, value) => {
    this.workspace.forEach((window) => {
      if (window.id === this.selectedWindowId) {
        window.styles[styleType] += value
      }
    })
  }

  //TOOLBAR
  //Включение лупы
  toggleMagnifier = () => {
    this.magnifier = !this.magnifier
  }
  zoom = (id, value) => {
    this.workspace.forEach((window) => {
      if (window.id === this.selectedWindowId) {
        window.styles.zoom += value
        if (window.styles.zoom < 0.4) window.styles.zoom += 0.5
      }
    })
  }
  setZoom = (id, value) => {
    this.workspace.forEach((window) => {
      if (window.id === id) {
        window.styles.zoom = value
      }
    })
  }
  brightness = (value) => {
    this.workspace.forEach((window) => {
      if (window.id === this.selectedWindowId) {
        window.styles.brightness = value
      }
    })
  }
  contrast = (value) => {
    this.workspace.forEach((window) => {
      if (window.id === this.selectedWindowId) {
        window.styles.contrast = value
      }
    })
  }
  invert = () => {
    this.workspace.forEach((window) => {
      if (window.id === this.selectedWindowId) {
        window.styles.invert = !window.styles.invert
      }
    })
  }
  rotate = (angl) => {
    this.workspace.forEach((window) => {
      if (window.id === this.selectedWindowId) {
		  let newangl = window.styles.rotate + angl;
		  //if (newangl > 270) newangl = 0;
		  //if (newangl < 0) newangl = 270;
		  window.styles.rotate = newangl;
      }
    })
  }
  mirrorH = (angl) => {
    this.workspace.forEach((window) => {
      if (window.id === this.selectedWindowId) {
		  window.styles.scaleY = -1 * window.styles.scaleY;
      }
    })
  }
  mirrorV = (angl) => {
    this.workspace.forEach((window) => {
      if (window.id === this.selectedWindowId) {
		  window.styles.scaleX = -1 * window.styles.scaleX;
      }
    })
  }

}

export default ViewerStore
